import './polyfills/ie11event.js';
import 'bootstrap';
import '../vendor/js/sharer.js';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
//import 'select2'; --> przeniesione do select2-without-above
import 'select2/dist/css/select2.css';
import 'jquery.cookie';
import 'jquery-ui';

import './simple-components/navbar.js';
import './simple-components/frontpage-autocomplete.js';
import './simple-components/frontpage-datepickers.js';
import './simple-components/frontpage-owlcarousel.js';
import './simple-components/frontpage-hrefs.js';
import './simple-components/faq-component.js';
import './simple-components/offers-component.js';
import './simple-components/footer-newsletter.js';
import './simple-components/tours-component.js';
import './simple-components/contact-component.js';
import './simple-components/job-component.js';
import './simple-components/tooltip-component.js';
import './simple-components/ios-click-fix.js';

import '../scss/main.scss';
